  const city_options = [

  { id:0, name: "My Location", color: 'red', class: 's'},
  { id:1, name: "New-York City", color: 'red', class: 'fm'},
  { id:2, name: "London City", color: 'red', class: 'fd'},
  { id:3, name: "Jaipur City", color: 'red', class: 'gh'},
  { id:4, name: "Brazil City", color: 'red', class: 'gc'},
];

export default city_options;